import React from 'react';

import Map from '../../components/Map/Map';

const PollsMap = () => {
  return (
    <div className="dashboard-components">
      <div className="dc-left full">
        <div className="sentiment-trend chart-component">
          <Map />
        </div>
      </div>
    </div>
  );
};

export default PollsMap;
